const Marquee = {
    "options": {
        "data": {
            "text": {
                "type": "Text"
            },
            "images": [
                {
                    "to": "",
                    "src": ""
                }
            ]
        },
        "customization": {},
        "widgets": {
            "Menu_titleSettings": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "titleSettings"
                },
                "options": {
                    "textSize": {
                        "type": "RangePx",
                        "data": {
                            "max": 30,
                            "min": 0,
                            "step": 1
                        },
                        "order": 2
                    },
                    "textColor": {
                        "type": "HexColor"
                    },
                    "textStyle": {
                        "type": "SelectBox",
                        "data": {
                            "selectOptions": [
                                "normal",
                                "italic"
                            ]
                        },
                        "order": 3
                    },
                    "textWeight": {
                        "type": "SelectBox",
                        "data": {
                            "selectOptions": [
                                "100",
                                "200",
                                "300",
                                "400",
                                "500",
                                "600",
                                "700",
                                "800",
                                "900"
                            ]
                        },
                        "order": 4
                    },
                    "backgroundColor": {
                        "type": "HexColor",
                        "order": 4
                    },
                    "textWordSpacing": {
                        "type": "RangePx",
                        "data": {
                            "max": 30,
                            "min": 0,
                            "step": 1
                        },
                        "order": 5
                    },
                    "textLetterSpacing": {
                        "type": "RangePx",
                        "data": {
                            "max": 30,
                            "min": 0,
                            "step": 1
                        },
                        "order": 6
                    }
                }
            },
            "Menu_GeneralSettings": {
                "order": 1,
                "type": "Menu",
                "renderOptions": {
                    "controlKey": "generalSettings"
                },
                "options": {
                    "containerPadding": {
                        "data": {
                            "max": 30,
                            "min": 0,
                            "step": 1,
                            "svgType": "border"
                        },
                        "type": "FourPx",
                        "order": 7
                    }
                }
            }
        }
    },
    "variants": [
        {
            "id": "1",
            "name": "classic",
            "type": "Marquee",
            "data": {
                "text": "",
                "images": [
                    {
                        "to": "",
                        "src": ""
                    }
                ]
            },
            "customization": {
                "textFont": "Arial",
                "textSize": "12px",
                "textColor": "#7059ef",
                "textStyle": "normal",
                "textWeight": "100",
                "backgroundColor": "#F0EEFB",
                "textWordSpacing": "4px",
                "textLetterSpacing": "4px",
                "containerPadding": "0px 0px 0px 0px"
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Text+Marquee%402x.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        }
    ]
}
 export default Marquee